import { useState, useEffect, useRef } from 'react';
import { gridReviews } from '../../../mocks/reviews';

export default function ReviewsSection() {
  const [visibleCards, setVisibleCards] = useState<boolean[]>(new Array(6).fill(false));
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            gridReviews.slice(0, 6).forEach((_, index) => {
              setTimeout(() => {
                setVisibleCards((prev) => {
                  const newState = [...prev];
                  newState[index] = true;
                  return newState;
                });
              }, index * 150);
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">고객 후기</h2>
          <p className="text-gray-600 text-lg">
            실제 고객들의 생생한 경험을 확인해보세요
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {gridReviews.slice(0, 6).map((review, index) => (
            <div
              key={review.id}
              className={`bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:shadow-xl hover:border-neon-pink/30 transition-all duration-500 hover:-translate-y-2 cursor-pointer group ${
                visibleCards[index] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <i
                    key={i}
                    className="ri-star-fill text-neon-pink group-hover:scale-110 transition-transform"
                    style={{ transitionDelay: `${i * 50}ms` }}
                  ></i>
                ))}
              </div>
              <h3 className="font-bold text-lg mb-3 group-hover:text-neon-pink transition-colors">
                {review.title}
              </h3>
              <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                {review.content}
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-neon-light rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                  <span className="text-neon-pink font-bold">
                    {review.author.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-sm">{review.author}</p>
                  <p className="text-gray-500 text-xs">{review.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/reviews"
            className="inline-block bg-gray-900 text-white px-8 py-3 rounded-full font-semibold hover:bg-neon-pink hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
          >
            전체 후기 보기
          </a>
        </div>
      </div>
    </section>
  );
}
